import { render, staticRenderFns } from "./GoogleSpreadsheetTemplateDetail.vue?vue&type=template&id=48738190"
import script from "./GoogleSpreadsheetTemplateDetail.vue?vue&type=script&lang=ts"
export * from "./GoogleSpreadsheetTemplateDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports